import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div className="min-h-screen mt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-10 pt-8 sm:pt-12 pb-16">
        <header className="mb-8">
          <p className="text-xs font-semibold tracking-[0.16em] text-green-900/75 uppercase mb-3">
            Legal
          </p>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">Privacy Policy</h1>
          <p className="mt-3 text-sm text-gray-600">
            Last updated: May 7, 2026
          </p>
        </header>

        <div className="space-y-7 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Information we collect</h2>
            <p>
              We collect account information, usage analytics, and subscription-related details
              needed to provide and improve MarketDataFYI.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">How we use information</h2>
            <p>
              Data is used to authenticate your account, deliver product features, support billing
              workflows, and monitor product reliability and abuse.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Third-party services</h2>
            <p>
              Payment processing and selected infrastructure functions may rely on third-party
              providers. Those providers process data under their own policies and security
              controls.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Contact</h2>
            <p>
              Privacy requests and questions can be sent to{' '}
              <a
                href="mailto:support@marketdatafyi.com"
                className="text-green-700 font-medium underline decoration-green-700/30 underline-offset-2"
              >
                support@marketdatafyi.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
